import axios from './api' // 倒入 api

import monitor from './apilist/monitor'
import report from './apilist/report'

// 平台用户登陆
export const loginMgr = params => {
    return axios({
        url: '/apilogin',
        method: 'get',
        params
    })
}

// 默认全部倒出
// 根绝需要进行
export default {
    loginMgr,
    ...monitor,
    ...report
}
